import { useAuth } from "@/store/auth";
import { useDevices } from "@/store/devices";
import { useViewer } from "viewer/store/viewer";
import { useStation } from "viewer/store/station";
import { useActivityLog } from "viewer/store/activityLog";
import { useEventFilters } from "viewer/store/eventFilters";
import { useEventDeletion } from "viewer/store/eventDeletion";

export default function clearSession() {
  log.app("Clearing session");

  useAuth.persist.clearStorage();
  useDevices.persist.clearStorage();
  useViewer.persist.clearStorage();
  useStation.persist.clearStorage();

  useStation.getState().resetState();
  useAuth.getState().resetState();
  useDevices.getState().resetState();
  useViewer.getState().resetState();
  useActivityLog.getState().resetState();
  useEventFilters.getState().resetState();
  useEventDeletion.getState().resetState();

  localStorage.removeItem("parseUser");
}
